export enum InternalTransferReducerActions {
  SET_PAYMENT,
  SET_SELECTION,
  SET_CONFIRM,
  SET_FAVORITE,
  SET_IS_FORM_PREFILL,
  SET_ERROR,
  SET_ERROR_MESSAGES,
  FILTER_ERROR_MESSAGE,
  SET_USER_NOTICE,
  SET_VALIDATION_RESULT,
  SET_PREFILLED_PAYMENT_OPTION,
  SET_LOADING,
  SET_INITIALIZED,
}
